import DefaultData from '../../lib/jin/svgchartlib/01_Charts/01_Donut/includes/primitives/Data'

export default DefaultData
